import apiClient from './client';

const login = (username,password) => apiClient.post('/jwt-auth/v1/token', { username, password });

export default{
    login,
}